import { render, staticRenderFns } from "./_RegistrationProvisional.vue?vue&type=template&id=452fe70f&scoped=true&"
import script from "./_RegistrationProvisional.vue?vue&type=script&lang=js&"
export * from "./_RegistrationProvisional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452fe70f",
  null
  
)

export default component.exports